export interface RemunerationAmountObject {
	id?: string | number;
	label?: string;
	value?: number;
	amount?: number;
}

export type RemunerationAmountOption = number | RemunerationAmountObject;

export interface SalaryTimeUnitDto {
	id: string;
	talentplugId: number;
	name: string;
}

export interface SalaryOptionDto {
	id: string;
	talentplugId: number;
	name: string;
	timeUnitId: number;
	timeUnit?: SalaryTimeUnitDto;
}

export interface RemunerationPeriodicityOptionDto {
	id: string;
	type: string;
	minimumValues: RemunerationAmountOption[];
	maximumValues: RemunerationAmountOption[];
	order: number;
}

export enum RemunerationPeriodicity {
	HOURLY = 'HOURLY',
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	YEARLY = 'YEARLY',
}

export interface Remuneration {
	periodicity: RemunerationPeriodicity | null;
	minimumAmount: number | null;
	maximumAmount: number | null;
}

export interface RemunerationPeriodicityOptionUi {
	id: string;
	label: string;
	value: RemunerationPeriodicity;
	minimumValues: RemunerationAmountOption[];
	maximumValues: RemunerationAmountOption[];
}
